import { render, staticRenderFns } from "./scMoreInfoShareWidget.vue?vue&type=template&id=54eacd5c&"
import script from "./scMoreInfoShareWidget.vue?vue&type=script&lang=js&"
export * from "./scMoreInfoShareWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports